<ng-container *ngIf="favoriteReports.length > 0; else emptyFav">
  <mat-nav-list class="h-100">
    <mat-list-item class="h-auto no-padding-list-item" *ngFor="let fav of favoriteReports; let lastItem = last;"
                   (click)="selectReport($event, fav)">
      <div class="container-fluid pt-1 pl-0 pr-0">
        <div class="row no-gutters">
          <div class="col-2 no-gutters align-self-center">
            <button color="accent" aria-label="Favorites Button" mat-icon-button (click)="manageFavorite($event, fav)">
              <mat-icon inline [fontSet]="fav.favorite ? 'fas' : 'far'" fontIcon="fa-star"></mat-icon>
            </button>
          </div>
          <div class="col-9 d-flex flex-column">
            <h5 class="mb-0 text-truncate" style="max-width: 15rem;" [matTooltip]="fav.name">{{ fav.name }}</h5>
            <div class="d-flex justify-content-between pt-2">
              <span class="sub-text">Schedule: {{ fav.schedule ? fav.schedule.type : '' }}</span>
              <div *ngIf="fav.schedule">
                <span
                  class="d-inline-block font-weight-bold px-2 m-auto rounded text-center text-uppercase text-white text-wrap font-small"
                  [ngClass]="(today - fav.schedule.endDateTime) > 0 ? 'bg-danger' : 'bg-warning'">
                  {{ (today - fav.schedule.endDateTime) > 0 ? 'EXPIRED' : 'EXPIRES' }} {{ fav.schedule.endDateTime | date: 'MM/dd/yyyy' }}
                </span>
              </div>
            </div>
            <span class="sub-text">
              Last run: {{ fav.historyExecutions && fav.historyExecutions.length > 0 ? (fav.historyExecutions[0].finalExecutionTime | date) : ''}}
            </span>
            <div class="d-flex pb-2 pt-1 justify-content-between">
              <button mat-icon-button color="primary" matTooltip="Run" aria-label="Run Button" *ngIf="!config?.hide?.run && fav.allowDistribution"
                      class="border border-dark rounded-icon" (click)="run($event, fav.id)">
                <mat-icon class="align-icon align-icon-run" fontSet="fas" fontIcon="fa-play"></mat-icon>
              </button>
              <button mat-icon-button color="primary" matTooltip="Details" aria-label="Report Details Button"
                      *ngIf="!config?.hide?.details && fav.allowDistribution"
                      class="border border-dark rounded-icon" (click)="openDetails(fav.id)">
                <mat-icon class="align-icon" fontSet="fas" fontIcon="fa-info"></mat-icon>
              </button>
              <button mat-icon-button color="primary" matTooltip="View" aria-label="View Button" *ngIf="!config?.hide?.run && fav.allowDistribution"
                      class="border border-dark rounded-icon" (click)="view($event, fav.id)">
                <mat-icon class="align-icon" fontSet="fas" fontIcon="fa-eye"></mat-icon>
              </button>
              <button mat-icon-button color="primary" matTooltip="Delete" aria-label="Delete Button" *ngIf="!config?.hide?.delete"
                      class="border border-dark rounded-icon" (click)="delete($event, fav.id)">
                <mat-icon class="align-icon" fontSet="fas" fontIcon="fa-trash"></mat-icon>
              </button>
              <div [ngClass]="fav.recipients[0] && fav.recipients[0].format === htmlFormat ? 'ml-4 pl-1' : ''">
                <button class="border border-dark rounded-icon" mat-icon-button color="primary" matTooltip="Download" *ngIf="fav.allowDistribution"
                        aria-label="Download Button" [hidden]="fav.recipients[0] && fav.recipients[0].format === htmlFormat"
                        (click)="download($event, fav.id, fav.name)">
                  <mat-icon class="align-icon" fontSet="fas" fontIcon="fa-file-download"></mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-1 align-self-center" *ngIf="!config?.disable?.rowClick && allowedScreens.includes(fav.screenName)">
            <mat-icon class="d-inline-block pl-2" fontSet="fas" fontIcon="fa-chevron-right"></mat-icon>
          </div>
        </div>
        <mat-divider *ngIf="!lastItem"></mat-divider>
      </div>
    </mat-list-item>
  </mat-nav-list>
</ng-container>

<ng-template #emptyFav>
  <div class="h-100 text-center align-center justify-content-between py-5">
    No favorite reports found.
  </div>
</ng-template>
